(function() {
	/**
   * Renders Mountain Weather Map Page (new data structure) — hardened
   * @param {Object} props - The Routing and page context and properties
   * @returns {jQuery.Deferred} Promise with data (nav for menu, etc.)
   */
	WebBaseAprovLV.renderMountainWeatherMapPage = function(props) {
		var Utils = (WebBaseAprovLV && WebBaseAprovLV.Utils) || {};
		var lang = WebBaseAprovLV.lang;
		var dfdRoot = $.Deferred();
		var t0 = (window.performance && performance.now && performance.now()) || Date.now();
		if (!Utils || !Utils.fetchAsync || !Utils.getKKData) {
			console.error('[mountain] Utils missing');
			return dfdRoot.reject(new Error('Utils missing')).promise();
		}
		var fetchAsync = Utils.fetchAsync({ dataType: 'json', cache: true, timeout: 12000 });
		var fetchFresh = Utils.fetchAsync({ dataType: 'json', cache: false, timeout: 12000 });
		function safeJSON(call, defaultVal, label) {
			var dfd = $.Deferred();
			call
			.done(function(resp) { dfd.resolve(resp); })
			.fail(function(_jq, textStatus, err) {
				console.warn('[mountain] failed:', label || 'request', textStatus || '', err || '');
				dfd.resolve(defaultVal);
			});
			return dfd.promise();
		}
		function asArray(v, fallback) {
			if (Array.isArray(v)) {
				if (v.length === 1 && Array.isArray(v[0])) {return v[0];}
				return v;
			}
			return (fallback || []);
		}
		function asObject(v, fallback) {
			if (v && typeof v === 'object' && !Array.isArray(v)) {return v;}
			return (fallback || {});
		}
		var params = {
			page: (props && props.context && props.context.params && props.context.params.page) || '',
			detail: (props && props.context && props.context.params && props.context.params.detail) || ''
		};
		var model = {
			element: null,
			template: 'templates/mountain-weather-map.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: asObject((props.context && props.context.Model && props.context.Model.Main) || {}, {}),
				pageRaw: null,
				pageContent: null,
				navRaw: null,
				nav: null,
				venueMountainAreasData: null,
				venueMountainSubregionsData: null,
				skyConditions: null,
				mountainData: null
			}
		};
		var langparam = (lang === 'lld' ? 'lld' : lang);
		var base = (WebBaseAprovLV.config.azureStorageUrl[lang] || '');
		var timeLayoutIds = ['144000000', '144001440'];
		var cb = Date.now();
		var pageReq = safeJSON(Utils.getKKData('?system.type=page&elements.url[in]=' + params.page + '&depth=1'),
			{}, 'kk page');
		var tplMain = safeJSON(ejs.preloadTemplate(model.template), true, 'tpl main');
		var tplBreadcrumb = safeJSON(ejs.preloadTemplate('templates/breadcrumb.ejs.html?v=' + WebBaseAprovLV.version.template), true, 'tpl breadcrumb');
		var tplBottom = safeJSON(ejs.preloadTemplate('templates/bottomnav.ejs.html?v=' + WebBaseAprovLV.version.template), true, 'tpl bottomnav');
		$.when(pageReq, tplMain, tplBreadcrumb, tplBottom).then(function(pageXhr) {
			var pageRaw = asObject(Array.isArray(pageXhr) ? pageXhr[0] : pageXhr, {});
			model.data.pageRaw = pageRaw;
			model.data.navRaw = {};
			var regionsReq = safeJSON(fetchAsync(base + 'forecast-data/website/static-data/mountain_regions.json'),
				[], 'regions');
			var elevReq = safeJSON(fetchAsync(base + 'forecast-data/website/static-data/elevations.json'),
				[], 'elevations');
			var skyReq = safeJSON(fetchAsync(base + 'forecast-data/website/static-data/sky_conditions.json'),
				[], 'sky');
			var bulletinReqs = timeLayoutIds.map(function(id) {
				var url = base + 'forecast-data/website/mountains/' + langparam + '_' + id + '.json'
                + (base.indexOf('?') === -1 ? ('?cb=' + cb) : ('&cb=' + cb));
				return safeJSON(fetchFresh(url).then(function(resp) {
					var r = Array.isArray(resp) ? resp[0] : resp;
					return r || null;
				}), null, 'bulletin:' + id);
			});
			return $.when.apply($, [regionsReq, elevReq, skyReq].concat(bulletinReqs));
		})
		.then(function() {
			var args = Array.prototype.slice.call(arguments);
			var regionsRaw = asArray(args[0], []);
			var elevRaw = asArray(args[1], []);
			var skyRaw = asArray(args[2], []);
			var publications = args.slice(3).map(function(v) { return v || null; }).filter(Boolean);
			var regions = (Utils.localizeMountainRecords && Utils.localizeMountainRecords(regionsRaw, lang)) || regionsRaw;
			var elevations = (Utils.localizeMountainRecords && Utils.localizeMountainRecords(elevRaw, lang)) || elevRaw;
			var regionIdx = (Utils.buildRegionIndexes && Utils.buildRegionIndexes(regions)) || {};
			var elevById = Object.create(null);
			elevations.forEach(function(v) {
				if (v && v.id != null) {elevById[String(v.id)] = v;}
			});
			var mergedMountainData = null;
			try {
				mergedMountainData = (Utils.mergeMountainBulletins
          && Utils.mergeMountainBulletins(publications, elevById, regionIdx, lang)) || null;
			} catch(err) {
				console.warn('[mountain] mergeMountainBulletins failed:', err);
				mergedMountainData = null;
			}
			model.element = $('#content');
			var kkVM = Utils.getKKViewModel || function(x) { return [x || {}]; };
			model.data = $.extend(model.data, {
				pageContent: (kkVM(model.data.pageRaw)[0] || {}),
				nav: (kkVM(model.data.navRaw)[0] || {}),
				venueMountainAreasData: regions,
				venueMountainSubregionsData: elevations,
				skyConditions: skyRaw || [],
				mountainData: mergedMountainData
			});
			return Utils.transitionTo(model);
		})
		.then(function(ejsmodel) {
			try {
				ejsmodel.data.UILangSwitch = Utils.tuneUILangSwitchers && Utils.tuneUILangSwitchers({
					page: { segment: { 'de': 'bergwetter', 'it': 'tempo-in-montagna', 'lld': 'temp-sa-mont', 'en': 'mountain-weather' } },
					detail: { id: '' }
				}, $('a.langchange'));
			} catch(err) {
				console.warn('[mountain] tuneUILangSwitchers skipped:', err);
			}
			var t1 = (window.performance && performance.now && performance.now()) || Date.now();
			console.info('[mountain] load+render took', Math.round(t1 - t0), 'ms');
			dfdRoot.resolve(ejsmodel);
		})
		.fail(function(err) {
			console.warn('[mountain] falling back to minimal render:', err);
			model.element = $('#content');
			model.data.pageContent = model.data.pageContent || {};
			model.data.nav = model.data.nav || {};
			model.data.venueMountainAreasData = model.data.venueMountainAreasData || [];
			model.data.venueMountainSubregionsData = model.data.venueMountainSubregionsData || [];
			model.data.skyConditions = model.data.skyConditions || [];
			model.data.mountainData = model.data.mountainData || null;
			$.when(Utils.transitionTo(model))
			.done(function(ejsmodel) { dfdRoot.resolve(ejsmodel); })
			.fail(function(e) { dfdRoot.reject(e); });
		});
		return dfdRoot.promise();
	};
})();
